import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/image/fanhui.png';

import { useRouter } from 'vue-router';
const _withScopeId = n => (_pushScopeId("data-v-44512872"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "icon"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "fanhui",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "14px",
    "color": "#fff"
  }
}, "返回", -1));
const _hoisted_5 = [_hoisted_3, _hoisted_4];
const _hoisted_6 = {
  class: "name"
};
const _hoisted_7 = {
  class: "more"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "46px"
  }
}, null, -1));
export default {
  __name: 'nav_header',
  props: {
    name: {
      type: String,
      default: '标题'
    },
    iconleft: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {
    const props = __props;
    const route = useRouter();
    let returnUp = () => {
      route.back();
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [__props.iconleft ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "left",
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(returnUp) && _unref(returnUp)(...args))
      }, _hoisted_5)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, _toDisplayString(__props.name), 1), _createElementVNode("div", _hoisted_7, [_renderSlot(_ctx.$slots, "more")])]), _hoisted_8], 64);
    };
  }
};